import { omit, equals } from 'ramda';

export const equalsState = (state, defaultState) => {
  const ignoredFields = ['fieldsDisabled',
    'id',
    'visibilities',
    'lines',
    'logo_id',
    'stamp_id',
    'should_be_registered?',
    'locked?',
    'dialogOpened',
  ];

  const filteredDefaultState = omit(ignoredFields, defaultState);
  const filteredState = omit(ignoredFields, state);

  return equals(filteredState, filteredDefaultState);
};
const nullToEmptyString = obj => Object.entries(obj).reduce((newObj, [key, value]) => {
  newObj[key] = value === null ? '' : value;
  return newObj;
}, {});

export const isDefaultLine = (line, defaultLine, customIgnored = null) => {
  const ignoredFields = customIgnored === null ? ['id'] : customIgnored;

  const filteredDefaultLine = omit(ignoredFields, nullToEmptyString(defaultLine));
  const filteredLine = omit(ignoredFields, nullToEmptyString(line));

  return equals(filteredLine, filteredDefaultLine);
};
